/*
 * Copyright (c) CIRROM 2025.
 */

import React from "react";
import styled from "@emotion/styled";
import { List } from "@mui/material";

import { MiraTheme } from "../../theme/theme";
import { SidebarItemsType } from "../../types/sidebar";
import { SidebarNavSection } from "./SidebarNavSection";

const Wrapper = styled.div<{ theme?: MiraTheme }>`
  background-color: ${(props) => props.theme.sidebar.background};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  flex-grow: 1;
`;

const Items = styled.div<{ theme?: MiraTheme }>`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`;

type SidebarNavProps = {
  items: {
    title: string;
    pages: SidebarItemsType[];
  }[];
  isCollapsed?: boolean;
};

export const SidebarNav: React.FC<SidebarNavProps> = ({
  items,
  isCollapsed = false,
}) => {
  return (
    <Wrapper>
      <List disablePadding>
        <Items>
          {items &&
            items.map((item) => (
              <SidebarNavSection
                component="div"
                key={item.title}
                pages={item.pages}
                title={item.title}
                isCollapsed={isCollapsed}
              />
            ))}
        </Items>
      </List>
    </Wrapper>
  );
};
